<template>
	<div id="app" style="position: relative;overflow: hidden;">
		<div style="position: absolute;top: 0;left: 0;z-index: 99;">
			<div style="margin: 0 50px;padding: 40px 0;position: relative;">
				<div class="menu">
					<!-- 绑定路由对应的标识，而非仅索引 -->
					<div ref="til" :class="idx == index ? 'item' : ''" v-for="(item, index) in navigationList"
						:key="index" @click="handleNavClick($event, index)">
						{{ item.name }}
					</div>
				</div>
				<div class="mark" :style="{ '--left': left, '--width': width }">
					<div class="lef"></div>
					<div class="rig"></div>
				</div>
			</div>
		</div>
		<transition name="slide-left" mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
export default {
	name: "app",
	components: {},
	data() {
		return {
			idx: 0,
			width: '0px',
			left: '0px',
			// 重构导航数据：关联路由路径，方便匹配
			navigationList: [
				{ name: "首页", path: "/" },
				{ name: "司机加入", path: "/join" },
				{ name: "关于我们", path: "/info" }
			],
			delLoading: false,
		};
	},
	mounted() {
		// 1. 先根据当前路由匹配选中的索引
		this.matchRouteToNav();
		// 2. 初始化选中项的位置和宽度
		this.updateMarkPosition();
		// 3. 监听路由变化，同步更新导航状态（解决手动改路由的情况）
		this.$router.afterEach(() => {
			this.matchRouteToNav();
			this.updateMarkPosition();
		});
	},
	methods: {
		// 根据路由匹配导航选中索引
		matchRouteToNav() {
			const currentPath = this.$route.path;
			const matchItem = this.navigationList.find(item => item.path === currentPath);
			// 匹配到则更新索引，否则默认选中首页
			this.idx = matchItem ? this.navigationList.indexOf(matchItem) : 0;
		},
		// 更新导航下划线的位置和宽度
		updateMarkPosition() {
			if (this.$refs.til && this.$refs.til[this.idx]) {
				const temp = this.$refs.til[this.idx].getBoundingClientRect();
				this.width = temp.width + 40 + 'px';
				this.left = temp.left - 70 + 'px';
			}
		},
		// 导航点击事件
		handleNavClick({ target }, index) {
			this.idx = index;
			// 立即更新下划线位置（提升交互体验）
			this.width = target.getBoundingClientRect().width + 40 + 'px';
			this.left = target.getBoundingClientRect().left - 70 + 'px';
			// 跳转对应路由
			const targetPath = this.navigationList[index].path;
			this.$router.push(targetPath);
		}
	}
};
</script>

<style>
#app {
	margin: 0;
	padding: 0;
	width: 100vw;
	height: 100vh;
}

.menu {
	font-size: 25px;
	width: 45vw;
	display: flex;
	justify-content: space-around;
}

.menu div {
	cursor: pointer;
}

.rightMenu {
	position: absolute;
	right: 0;
	top: 0;
	display: flex;
	flex-wrap: wrap;
	width: 25vw;
	justify-content: center;
}

.mark {
	margin-top: 1rem;
	display: flex;
	width: var(--width);
	position: absolute;
	left: var(--left);
	transition: all 0.5s;
	transition-timing-function: ease-in-out;
	height: 4px;
}

.item {
	font-weight: bolder;
}

.lef {
	flex: 3;
	background-color: #ffc15a;
}

.rig {
	flex: 7;
	background-color: #3e83ea;
}

.slide-left-enter {
	opacity: 0;
	-webkit-transform: translate(30px, 0);
	transform: translate(30px, 0);
}

.slide-left-enter-active {
	transition: all .5s ease;
}

.slide-left-leave-to {
	opacity: 0;
	-webkit-transform: translate(-30px, 0);
	transform: translate(-30px, 0);
}

.slide-left-leave-active {
	transition: all 0.2s ease;
}
</style>